/**
 * Configuration management for Redo Shopify Extension
 */

import { parseUrl } from "@redotech/util/url";
import { InternalAppStatusEmitter as InternalAppStatusEmitterClass } from "./utils/internal-app-events";

/**
 * Redo storefront configuration interface
 */
export interface RedoStorefrontConfig {
  type:
    | "shopify"
    | "shopify-tapcart"
    | "bigcommerce"
    | "commercecloud"
    | "commentsold"
    | "custom-lightopia"
    | "miva";
  storeUrl?: string;
  env?: Record<string, string>;
  miva?: { root?: string; storeCode: string };
  tryFirst?: any;
  timing?: any;
  marketing?: { embeddedForms?: { [key: string]: any }[] };
  internalAppStatusEmitter?: globalThis.InternalAppStatusEmitter;
}

/**
 * Get or create the global Redo storefront configuration
 * Creates a default configuration if one doesn't exist
 */
export function getRedoStorefrontConfig(): RedoStorefrontConfig {
  if (!globalThis.redoStorefront) {
    globalThis.redoStorefront = {
      type: "shopify",
      storeUrl:
        globalThis.Shopify?.shop ?? globalThis.Shopify?.Checkout?.apiHost,
    };
  }

  if (!globalThis.redoStorefront.storeUrl) {
    globalThis.redoStorefront.storeUrl =
      globalThis.Shopify?.shop ?? globalThis.Shopify?.Checkout?.apiHost;
  }

  if (
    globalThis.redoCoveragePreviewProxy &&
    (globalThis.redoStorefront.type !== "shopify" ||
      globalThis.redoCoveragePreviewProxy.sourceUrl.includes("myshopify"))
  ) {
    try {
      const sourceUrl = parseUrl(globalThis.redoCoveragePreviewProxy.sourceUrl);
      globalThis.redoStorefront.storeUrl = sourceUrl.hostname;
    } catch {
      // ignore invalid proxy source URL
    }
  }

  return globalThis.redoStorefront;
}

/**
 * Get or create the internal app status emitter
 * Creates a new emitter instance if one doesn't exist and sets up demo logging
 */
export function getInternalAppStatusEmitter(): globalThis.InternalAppStatusEmitter {
  const config = getRedoStorefrontConfig();

  if (!config.internalAppStatusEmitter) {
    config.internalAppStatusEmitter = new InternalAppStatusEmitterClass();
  }

  return config.internalAppStatusEmitter;
}
